import React, { useEffect, useRef, useState } from "react";
import "./HomeIptvCard.scss";

import tajikPng from "../../../../Assets/Home/img/HomeIptv/tajik.png";
import tajikWebp from "../../../../Assets/Home/img/HomeIptv/tajik.webp";
import sportPng from "../../../../Assets/Home/img/HomeIptv/sport.png";
import sportWebp from "../../../../Assets/Home/img/HomeIptv/sport.webp";
import kinoPng from "../../../../Assets/Home/img/HomeIptv/kino.png";
import kinoWebp from "../../../../Assets/Home/img/HomeIptv/kino.webp";
import kidsPng from "../../../../Assets/Home/img/HomeIptv/kids.png";
import kidsWebp from "../../../../Assets/Home/img/HomeIptv/kids.webp";
import funPng from "../../../../Assets/Home/img/HomeIptv/fun.png";
import funWebp from "../../../../Assets/Home/img/HomeIptv/fun.webp";

/*
  Своя картинка на категорию. Ключ — название из данных: id в IptvCannel
  идут подряд и при добавлении категории поедут, а названия привязаны к
  контенту. Категории без своего ассета показываются без картинки —
  чужую не подставляем.
  Размеры зашиты из самих файлов: без width/height браузер не резервирует
  место и первая отрисовка дёргается.
*/
const SLIDES = {
  "Таджикские": { png: tajikPng, webp: tajikWebp, w: 800, h: 792 },
  "Спортивные": { png: sportPng, webp: sportWebp, w: 800, h: 742 },
  "Кино": { png: kinoPng, webp: kinoWebp, w: 800, h: 764 },
  "Детские": { png: kidsPng, webp: kidsWebp, w: 780, h: 800 },
  "Развлекательные": { png: funPng, webp: funWebp, w: 797, h: 800 },
};

// Сколько живёт уходящий текстовый слой (должно совпадать с CSS)
const TEXT_OUT_MS = 170;

const HomeIptvCard = ({ activeTitleIptv, categories = [], index = 0 }) => {
  const category = categories[index];

  // Уходящий текст рисуем вторым слоем поверх: иначе React снимает старый
  // блок мгновенно и анимации ухода не видно.
  const [leaving, setLeaving] = useState(null);
  const lastIndex = useRef(index);

  useEffect(() => {
    if (lastIndex.current === index) return;
    setLeaving(lastIndex.current);
    lastIndex.current = index;
    const timer = setTimeout(() => setLeaving(null), TEXT_OUT_MS);
    return () => clearTimeout(timer);
  }, [index]);

  const renderText = (item, out) =>
    item ? (
      <div
        className={"homeIptvCard_item" + (out ? " homeIptvCard_item--out" : "")}
        aria-hidden={out ? "true" : undefined}
      >
        <p className="homeIptvCard_eyebrow">{item.title}</p>
        <h3>{item.subTitle}</h3>
        <p className="homeIptvCard_desc">
          Любимые фильмы, программы и сериалы в отличном качестве и без рекламы
        </p>
      </div>
    ) : null;

  return (
    <a href="#tarifs" className="homeIptvCard_block" onClick={() => activeTitleIptv()}>
      {/* Все слайды лежат друг на друге и только меняют прозрачность:
          размонтирование давало бы мигание и повторную загрузку. */}
      <div className="homeIptvCard_art" aria-hidden="true">
        {categories.map((e, i) => {
          const slide = SLIDES[e?.title];
          if (!slide) return null;
          return (
            <picture
              key={e.id}
              className={
                "homeIptvCard_slide" + (i === index ? " homeIptvCard_slide--active" : "")
              }
            >
              <source type="image/webp" srcSet={slide.webp} />
              <img
                src={slide.png}
                alt=""
                width={slide.w}
                height={slide.h}
                loading={i === 0 ? undefined : "lazy"}
              />
            </picture>
          );
        })}
      </div>

      <div className="homeIptvCard_textbox">
        {leaving !== null && renderText(categories[leaving], true)}
        <div key={index} className="homeIptvCard_textin">
          {renderText(category, false)}
        </div>
      </div>
    </a>
  );
};

export default HomeIptvCard;
